import {Component, OnInit, Input} from '@angular/core';
import {ColorListConfigurations} from './color.list.configurations';
import {TitleConfigurations, TitleLineConfigurations} from '../title/title.configurations';
import {KlaHttpService} from '../services/kla.http.service';
import { Image } from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { BadgesComponent } from '../badges/badges.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-color-list',
  templateUrl: './color-list.component.html',
  styleUrls: ['./color-list.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, BadgesComponent, SocialMediaButtonsComponent, StripSpecialCharsPipe, DynamicContentComponent ]
})
export class ColorListComponent implements OnInit {

  @Input()
  public config: ColorListConfigurations;

  @Input()
  public imageObject: Image;

  public titleConfigurations: TitleConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  public imagePath: string;

  constructor(private httpService: KlaHttpService) { }

  ngOnInit() {
    if (!this.config) {
      this.config = <ColorListConfigurations> {};
    }

    if (!this.config.color) {
      this.config.color = '#fff';
    }
    if (!this.config.buttonColor) {
      this.config.buttonColor = '#fff';
    }

    this.titleConfigurations = {
      header: this.config.header,
      title: this.config.title,
      description: this.config.description,
      color: this.config.color,
      badges: this.config.badges,
      footer: ''
    };
  }

  navigate(url: string) {
    window.open(url, '_blank');
  }
}
